import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { Page, type AiIndexDict } from "./ai.index";

export const Route = createFileRoute("/vi/ai/")({
  head: () => ({
    meta: [
      { title: "Công cụ AI cho doanh nghiệp — Banana Cards" },
      { name: "description", content: "Bộ công cụ AI: tạo hợp đồng, viết email và tìm kiếm khách hàng tiềm năng." },
    ],
    links: alternateLinkList("/ai", "vi"),
  }),
  component: PageVi,
});

const DICT_VI: AiIndexDict = {
  breadcrumb: "Công cụ AI",
  badge: "Công cụ AI miễn phí từ Banana",
  h1a: "Công cụ AI miễn phí cho công việc",
  h1b: "giúp bạn kiếm tiền.",
  intro: "Soạn hợp đồng, tìm khách hàng, viết email — chỉ trong vài giây, ngay trên trình duyệt, không cần thẻ tín dụng. Chạy trên cùng engine với nền tảng Banana.",
  tryIt: "Dùng thử miễn phí",
  comingSoon: "Sắp ra mắt",
  moreA: "Thêm công cụ miễn phí,",
  moreB: "đang trên đường.",
  live: [
    { to: "/vi/ai/contract-generator", name: "Trình tạo hợp đồng AI", desc: "Soạn NDA, hợp đồng freelance, hợp đồng dịch vụ và hơn thế — sẵn sàng ký điện tử." },
    { to: "/vi/ai/lead-finder", name: "Tìm khách hàng bằng AI", desc: "Tìm khách hàng B2B và khách hàng địa phương trên Google Maps bằng tiếng Việt tự nhiên." },
    { to: "/vi/ai/email-writer", name: "Trợ lý viết email AI", desc: "Email cold, theo dõi và chào mừng — đúng tông giọng, đúng thương hiệu, sẵn sàng gửi." },
  ],
  soon: [
    { name: "Trình tạo Bio AI", desc: "Tạo bio chuyên nghiệp ấn tượng cho danh thiếp số của bạn." },
    { name: "Trình tạo QR Code AI", desc: "Tạo QR code đúng thương hiệu dẫn tới bất cứ đâu — và theo dõi lượt quét." },
    { name: "Trả lời đánh giá bằng AI", desc: "Trả lời mọi đánh giá Google với câu trả lời đúng thương hiệu trong vài giây." },
    { name: "Trình tạo đề xuất AI", desc: "Biến một brief dự án thành đề xuất đẹp, có thương hiệu." },
  ],
};

function PageVi() {
  return <Page dict={DICT_VI} />;
}